import React from "react";
import Service from "./Service";
import About from "./About";

export default function Aboutus() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>About Us</h1>
                    
                </div>
                
            </div>
            <div className="about-maintext" >
            {/* <h6 className="about-us-title"><i class="fa-regular fa-paper-plane" style={{color: '#b80505',transform: 'rotate(45deg)'}}></i> ABOUT US <i class="fa-solid fa-earth-americas" style={{color: '#b50808'}}></i></h6> */}
                <h6 className="about-description" style={{ fontSize: '18px',textAlign:'center',lineHeight:'2.6' }}>
                    In today’s fast-evolving markets, businesses face constant disruption—from shifting customer
                    expectations and emerging technologies to increased competition from agile new
                    players. Navigating these challenges requires a clear vision, strategic
                    action, and robust operational support
                    Our expert consultants specialize in vendor management, pricing, budget planning, and administrative excellence to help you reach your goals.<br />

                    Ready to grow? Contact us to build a sustainable, competitive edge in the digital era.

                </h6>
            </div>
            {/* <About /> */}
            <Service />
        </>
    )
}